import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { useLang } from "../../translations";
import { FadeUp } from "./Reveal";

export const Faq = () => {
  const { t } = useLang();
  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-36 bg-cream">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-12">
        <FadeUp>
          <p className="text-xs uppercase tracking-[0.28em] text-sage mb-4 text-center">{t.faq.label}</p>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-[3.4rem] text-ink leading-[1.05] tracking-tight text-center mb-14">
            {t.faq.title}
          </h2>
        </FadeUp>
        <FadeUp delay={0.1}>
          <Accordion type="single" collapsible className="w-full">
            {t.faq.items.map((it, i) => (
              <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="border-b border-ink/10">
                <AccordionTrigger className="text-left font-heading text-xl md:text-2xl text-ink hover:text-sage hover:no-underline py-6">
                  {it.q}
                </AccordionTrigger>
                <AccordionContent className="text-base text-muted2 leading-relaxed pb-6">
                  {it.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </FadeUp>
      </div>
    </section>
  );
};
